import { components } from 'cng-web-lib'
import React from 'react'
import { useParams } from 'react-router-dom'
import SCOInvMgmtApiUrls from 'src/apiUrls/SCOInvMgmtApiUrls'
import pathMap from 'src/paths/PathMap_SCO_InvMgmt'
import FormProperties from './Category_FormProperties'
import CategoryTranslationText from './CategoryTranslationText'

const {
    form: {
        CngEditFormButtonSection
    },
    button: { CngSecondaryButton },
    CngGridItem
} = components

const { form: { CngEditForm } } = components

function EditPage({ history, showNotification }) {
    const { id } = useParams()
    const translatedTextObject = CategoryTranslationText()

    return (

        <CngEditForm
            fieldLevel='toBeChangedByDeveloperIfWantFieldLevelRestriction'
            showNotification={showNotification}
            bodySection={
                <FormProperties.Fields
                    disabled={false}
                    showNotification={showNotification}
                    id={id}
                    isEdit={true}
                />
            }
            renderButtonSection={() => (
                <CngEditFormButtonSection>
                    <CngGridItem>
                        <CngSecondaryButton
                            onClick={() => { history.push(pathMap.SCO_INV_CATEGORY_LIST) }}>
                            {translatedTextObject.cancel}
                        </CngSecondaryButton>
                    </CngGridItem>
                </CngEditFormButtonSection>
            )}
            formikProps={FormProperties.formikProps}
            toClientDataFormat={FormProperties.toClientDataFormat}
            toServerDataFormat={FormProperties.toServerDataFormat}
            fetch={{
                url: `${SCOInvMgmtApiUrls.GET_CATEGORY_BY_ID}`
            }}
            update={{
                url: SCOInvMgmtApiUrls.UPDATE_CATEGORY,
                successRedirect: pathMap.SCO_INV_CATEGORY_LIST
            }}
            id={id}
        />
    )

}

export default EditPage
